export default __webpack_public_path__ + "static/media/landing-logo.5d8ba7d0.png";